import axios from "axios"
import { AuthApi } from "../services/Api"
import { ROLE } from "../services/Macro"
import { encrypUtil } from "./EncrypUtil"

class Checker {

    /** 校验是否登录 */
    async checkLogin(role: ROLE, page: string = '') {
        let token = localStorage.getItem('token') || null
        let lang = localStorage.getItem('lang') || "zh_CN"
        if (!token) {
            window.location.href = '/'
            return false
        }
        let requestData: any = {
            role: role,
            token: token,
            lang: lang.split('_')[0]
        }
        if (page && page.length > 0) {
            requestData['page'] = page
        }
        let params = await encrypUtil.encodeRequestRsa(requestData)
        console.log(`requestData:`, requestData)
        const response = await axios.post(AuthApi.CHECK_LOGIN, params)
        console.log(`response.data:`, response.data)
        if (400 === response.data.code) {
            window.location.href = '/'
            return false
        }
        return true
    }

}

export let checker = new Checker()